import type { IconSvgObject } from './types';

const Notion02Icon: IconSvgObject = [
  ["path", { d: "M2.5 3.5L16.5 2.5L21.5 5.5M2.5 3.5L6.5 6.5M2.5 3.5V16.5L6.5 21.5M21.5 5.5L6.5 6.5M21.5 5.5V19.5L6.5 21.5M6.5 6.5V21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.4704 17.704L9.5 18.1M18.5 8.70001L16.2654 8.84899M17.5 8.76668V17L11.7148 9.15236L9.5 9.30001M11 9.20001V17.7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Notion02Icon;
